import { useEffect, useState, forwardRef, ReactElement } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useMutation } from '@tanstack/react-query';
import api from '../components/api';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import * as z from "zod";
import { zodResolver } from '@hookform/resolvers/zod';


import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";

const Transition = forwardRef(function Transition(
    props: TransitionProps & { children: ReactElement<any, any> },
    ref
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const schema = z.object({
    senha: z.string().min(5, 'Senha precisa ter no mínimo 5 caracteres!'),
    confirmaSenha: z.string().min(5, 'Senha precisa ter no mínimo 5 caracteres'),
  }).refine((data) => data.senha === data.confirmaSenha, {
    message: 'As senhas não coincidem',
    path: ['confirmaSenha'],
  });

type FormData = z.infer<typeof schema>


const ModalSenha = (props: any) => {

    const [show, setShow] = useState<boolean>(props.show)
    const [usuario_id, setUsuario_id] = useState<number>()


    const [open, setOpen] = useState<boolean>(false);   

    const [acao, setAcao] = useState<string | undefined>('')

    const [titulo, setTitulo] = useState<string | undefined>('')
    const [frase, setFrase] = useState<string | undefined>('')

    const [dados, setDados] = useState<FormData>()


    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>({
        resolver: zodResolver(schema)
      })
    /*


    routes.post('/usuarioAlteraSenha/:usuario_id', celebrate({
        [Segments.PARAMS]: Joi.object().keys({
            usuario_id: Joi.number().integer().required()
        }),
        [Segments.BODY]: Joi.object().keys({
            senha: Joi.string().required().max(50),
            ad_usr: Joi.number().integer().required(),
        })
    }), verificaToken, usuarioController.alteraSenha)


    */



    const dadosUsuarios = sessionStorage.getItem('dadosUsuarios')

    useEffect(() => {

		if (dadosUsuarios) {

			var dados = JSON.parse(dadosUsuarios)
		    setUsuario_id(dados.usuario_id)
            
	

		}

	}, [dadosUsuarios])


    const { mutate: salvaMutation } = useMutation({

        mutationKey: ['alteraSenha', dados],
        mutationFn: async () => {


            setOpen(false)

            var dataPost = {

                senha: dados?.senha,
                ad_usr: usuario_id,

            }

            //console.log(dataPost)
            //return false

            const result = await api.post(`usuarioAlteraSenha/${usuario_id}`, dataPost)
            return result.data ?? {}

        },
        onSuccess: (data: any) => {

            if (data.status == 'ok') {

                props.setShow(false)
                toast.success('Senha alterada com sucesso!')
                reset()

            }

        },

        onError: (err: any) => {

            console.log(err.response)
            throw err

        }

    })


    const confirmaSalvar = async (data: FormData) => {


        setOpen(true)
        setTitulo('Confirmação')
        setFrase('Confirma alterar a senha?')
        setDados(data)


    }


    useEffect(() => {

        
        setShow(props.show);
        //setUsuario_id(props.usuario_id)
                
    }, [props.show, props.usuario_id, props.now]);


    return (

        <div>


            <Modal
                size="lg"
                show={show}
                onHide={() => setShow(false)}
                aria-labelledby="example-modal-sizes-title-lg"
                >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">

                    
                        Alterar senha



                </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <div className="row g-3">    

                        <div className="col-md-12">
                            <label className="form-label">Senha</label>
                            <input type="password" className="form-control" {...register('senha')} />
                        </div>

                        <div className="col-md-12">
                            <label className="form-label">Confirma senha</label>
                            <input type="password" className="form-control" {...register('confirmaSenha')} />
                            {errors.confirmaSenha && (
                            <small className="text-danger">
                                {errors.confirmaSenha.message}
                            </small>
                            )}
                        </div>


                        <div className="col-12" style={{ textAlign: 'right'}}>
                                                        
                            <button type="button" className="btn btn-dark" onClick={() => props.setShow(false)}>Fechar</button>&nbsp;
                            <button type="button" className="btn btn-success"  onClick={handleSubmit(confirmaSalvar)}>Salvar</button>&nbsp;
                            
                            
                            
                        </div>

                    </div>

                </Modal.Body>

            </Modal>




            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column" }}>

                    <div style={{ textAlign: 'justify' }}>
                        {frase}
                    </div>

                </DialogContent>
                <DialogActions>

                    <Button color="success" variant="contained" onClick={() => salvaMutation()} >
                        Ok
                    </Button>

                    <Button color="error" variant="contained" onClick={() => setOpen(false)} style={{ display: acao == '' ? 'table-row' : 'none' }}>
                        Cancelar
                    </Button>
                    

                </DialogActions>
            </Dialog>




        </div>

    )

}

export default ModalSenha